import './component-amount-selector.scss';
import { html } from 'lit';
import ComponentBase from './component-base';

class ComponentAmountSelector extends ComponentBase {

    static get tagName() { return 'component-amount-selector' }

    constructor() {
        super();
        this.buttons = [
            { value: 1 },
            { value: 2 },
            { value: 3 },
            { value: "←" },
            { value: 4 },
            { value: 5 },
            { value: 6 },
            { value: "" },
            { value: 7 },
            { value: 8 },
            { value: 9 },
            { value: "" },
            { value: 'C' },
            { value: 0 },
            { value: ',' },
            { value: "" }
        ]
        this.iniQty = 0;
        this.ok = false;
    }

    OnClick(value) {
        if (value === "")
            return;

        const qty = this.querySelector('input#quantity');

        if (value === "←") {
            qty.value = qty.value.length > 1 ? qty.value.substring(0, qty.value.length - 1) : 0;
            this.OnAmountChange(qty.value)
            return;
        }

        if (value === 'C') {
            qty.value = 0;
            this.OnAmountChange(qty.value)
            return;
        }

        if (value === ',') {
            if (qty.value.indexOf('.') != -1)
                return;

            qty.value += '.';
            this.OnAmountChange(qty.value)
            return;
        }

        const decimals = qty.value.split('.')[1];
        if (decimals && decimals.length > 1) {
            this.OnAmountChange(qty.value)
            return;
        }

        qty.value += '' + value;

        if ((qty.value == 0 && qty.value !== "0.0" && qty.value !== "0.00") || value !== 0)
            qty.value = parseFloat(qty.value)

        this.OnAmountChange(qty.value)
    }

    OnAmountChange(amount) {
        const event = new CustomEvent('amountChange', {
            bubbles: true,
            composed: true,
            detail: { amount }
        });
        this.dispatchEvent(event);
    }

    render() {
        return html`
            <input type="text" readonly .value=${this.iniQty} class="form-control" id="quantity">
            <div class="quantity-selector">
            ${this.buttons.map(button => html`
                <div @click=${() => { this.OnClick(button.value) }}>${button.value}</div>
            `)}
            </div>
        `;
    }

}
ComponentAmountSelector.Register();
export default ComponentAmountSelector;